// Height of the price plot alone (axis labels included) - TRANSACTIONS_ROW_HEIGHT below adds the rest.
export const CHART_PLOT_HEIGHT = 280;
// Reserved via chart.spacingBottom for the "Transakcje w RCN" caption + per-month counts/bars.
export const TRANSACTIONS_ROW_HEIGHT = 90;
export const CHART_HEIGHT = `${CHART_PLOT_HEIGHT + TRANSACTIONS_ROW_HEIGHT}px`;

export const TRANSACTIONS_LABEL_OFFSET = 24;
export const TRANSACTIONS_NUMBER_OFFSET = 24;
export const TRANSACTIONS_BAR_GAP = 8;
export const TRANSACTIONS_BAR_MAX_HEIGHT = 24;
export const TRANSACTIONS_BAR_MIN_HEIGHT = 2;
export const TRANSACTIONS_BAR_MAX_WIDTH = 10;
export const TRANSACTIONS_BAR_MIN_WIDTH = 3;
// Share of the space between two month ticks, not a fixed px value - a fixed width left bars touching on mobile.
export const TRANSACTIONS_BAR_WIDTH_RATIO = 0.4;
export const TRANSACTIONS_BAR_OPACITY_ACTIVE = 0.75;
export const TRANSACTIONS_BAR_OPACITY_PRELIMINARY = 0.22;

// font-size/caption-medium (info_txt_2), hardcoded - Highcharts doesn't use the Text component.
export const TRANSACTIONS_NUMBER_FONT_SIZE_DESKTOP = "1.106rem";
export const TRANSACTIONS_NUMBER_FONT_SIZE_MOBILE = "0.948rem";
export const TRANSACTIONS_NUMBER_LINE_HEIGHT = "1.2rem";
// Below this spacing, numbers would collide - every other one is dropped; bars still render for every month.
export const TRANSACTIONS_NUMBER_MIN_SPACING = 30;

// Outline around the tapped bar on mobile - a thin rounded rect hugging it, not a filled highlight.
export const ACTIVE_BAR_OUTLINE_PADDING = 2.5;
export const ACTIVE_BAR_OUTLINE_RADIUS = 3.25;
export const ACTIVE_BAR_OUTLINE_STROKE_WIDTH = 1.5;

export const PILL_TOP_OFFSET = 12;

export const RP_SERIES_NAME = "Ofertowa (RP), mies.";
export const RCN_SERIES_NAME = "Transakcyjna (RCN), mies.";
// Height of the price plot alone (axis labels included) - TRANSACTIONS_ROW_HEIGHT below adds the rest.
export const CHART_PLOT_HEIGHT = 280;
// Reserved via chart.spacingBottom for the "Transakcje w RCN" caption + per-month counts/bars.
export const TRANSACTIONS_ROW_HEIGHT = 90;
export const CHART_HEIGHT = `${CHART_PLOT_HEIGHT + TRANSACTIONS_ROW_HEIGHT}px`;

export const TRANSACTIONS_LABEL_OFFSET = 24;
export const TRANSACTIONS_NUMBER_OFFSET = 24;
export const TRANSACTIONS_BAR_GAP = 8;
export const TRANSACTIONS_BAR_MAX_HEIGHT = 24;
export const TRANSACTIONS_BAR_MIN_HEIGHT = 2;
export const TRANSACTIONS_BAR_MAX_WIDTH = 10;
export const TRANSACTIONS_BAR_MIN_WIDTH = 3;
// Share of the space between two month ticks, not a fixed px value - a fixed width left bars touching on mobile.
export const TRANSACTIONS_BAR_WIDTH_RATIO = 0.4;
export const TRANSACTIONS_BAR_OPACITY_ACTIVE = 0.75;
export const TRANSACTIONS_BAR_OPACITY_PRELIMINARY = 0.22;

// font-size/caption-medium (info_txt_2), hardcoded - Highcharts doesn't use the Text component.
export const TRANSACTIONS_NUMBER_FONT_SIZE_DESKTOP = "1.106rem";
export const TRANSACTIONS_NUMBER_FONT_SIZE_MOBILE = "0.948rem";
export const TRANSACTIONS_NUMBER_LINE_HEIGHT = "1.2rem";
// Below this spacing, numbers would collide - every other one is dropped; bars still render for every month.
export const TRANSACTIONS_NUMBER_MIN_SPACING = 30;

// Outline around the tapped bar on mobile - a thin rounded rect hugging it, not a filled highlight.
export const ACTIVE_BAR_OUTLINE_PADDING = 2.5;
export const ACTIVE_BAR_OUTLINE_RADIUS = 3.25;
export const ACTIVE_BAR_OUTLINE_STROKE_WIDTH = 1.5;

export const PILL_TOP_OFFSET = 12;

export const RP_SERIES_NAME = "Ofertowa (RP), mies.";
export const RCN_SERIES_NAME = "Transakcyjna (RCN), mies.";
